import { render, staticRenderFns } from "./dynamic-form-renderer-read-only.vue?vue&type=template&id=f5cd7bce&scoped=true"
import script from "./dynamic-form-renderer-read-only.vue?vue&type=script&lang=js"
export * from "./dynamic-form-renderer-read-only.vue?vue&type=script&lang=js"
import style0 from "./dynamic-form-renderer-read-only.vue?vue&type=style&index=0&id=f5cd7bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cd7bce",
  null
  
)

export default component.exports